import React, { useRef } from "react";
import moment from "moment";
import Draggable from "react-draggable";
import LoadingOverlay from "react-loading-overlay";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import Loader from "../../common/components/Loader";
import "./survey-project.css";

const SignatureViewModal = ({ onCancel = () => {}, signature = null, loading = false, onReload = () => {} }) => {
    const reloadedUrlRef = useRef(null);

    const handleImageError = () => {
        if (signature?.url && reloadedUrlRef.current !== signature.url) {
            reloadedUrlRef.current = signature.url;
            onReload();
        }
    };

    const metaFields = [
        { label: "Signed By", value: signature?.signed_by_name },
        { label: "Signed At", value: signature?.signed_at ? moment(signature.signed_at).format("MM-DD-YYYY h:mm A") : "" },
        { label: "Source", value: signature?.source, className: "text-capitalize" },
        { label: "Device Id", value: signature?.device_id }
    ];

    return (
        <div
            id="modalId"
            className="modal modal-region signature-view-modal"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="signatureModalLabel"
            aria-hidden="true"
        >
            <Draggable handle=".signature-drag-handle" cancel="button, img, .md-grp-btn">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header signature-drag-handle d-flex align-items-center justify-content-between">
                            <h5 className="modal-title" id="signatureModalLabel">
                                Signature
                            </h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={onCancel}>
                                <span aria-hidden="true">
                                    <img src="/img/close.svg" alt="" />
                                </span>
                            </button>
                        </div>
                        <div className="modal-body region-otr p-3">
                            <LoadingOverlay active={loading} spinner={<Loader />} fadeSpeed={10}>
                                {loading ? (
                                    <div className="signature-empty" />
                                ) : signature?.url ? (
                                    <>
                                        <div className="signature-image-section">
                                            <TransformWrapper defaultScale={1}>
                                                {({ zoomIn, zoomOut }) => (
                                                    <React.Fragment>
                                                        <div className="md-grp-btn">
                                                            <button onClick={zoomIn}>
                                                                <img src="/img/zoom-in.svg" alt="" />
                                                            </button>
                                                            <button onClick={zoomOut}>
                                                                <img src="/img/zoom-out.svg" alt="" />
                                                            </button>
                                                        </div>
                                                        <TransformComponent>
                                                            <img
                                                                src={signature.url}
                                                                alt="Signature"
                                                                style={{ maxHeight: "254px", maxWidth: "100%" }}
                                                                onError={handleImageError}
                                                            />
                                                        </TransformComponent>
                                                    </React.Fragment>
                                                )}
                                            </TransformWrapper>
                                        </div>
                                        <div className="signature-meta mt-3">
                                            {metaFields.map(field =>
                                                field.value ? (
                                                    <div className="signature-meta-item" key={field.label}>
                                                        <span className="signature-meta-label">{field.label}</span>
                                                        <span className={`signature-meta-value ${field.className ?? ""}`}>{field.value}</span>
                                                    </div>
                                                ) : null
                                            )}
                                        </div>
                                    </>
                                ) : (
                                    <div className="signature-empty text-center p-4 d-flex align-items-center justify-content-center">
                                        No signature found
                                    </div>
                                )}
                            </LoadingOverlay>
                        </div>
                    </div>
                </div>
            </Draggable>
        </div>
    );
};

export default SignatureViewModal;
